<template lang="html">
  <div style="background-color: #fff;">
    <van-nav-bar title="课程详情" left-text="返回" left-arrow :fixed="true" @click-left="$router.back()"/>
    <div style="height: 1.22667rem;"></div>

      <van-sticky offset-top="1.22667rem" style="height: 50px;">
        <van-search v-model="searchKey" shape="round" placeholder="请输入课程名称" />
      </van-sticky>     
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad">
          <van-cell v-for="item in list" :key="item" >
              <template #title>
               
                <div style="font-size: 0.4rem;font-weight: bold;"> 张加强-新注册 </div>
                              
                  <van-row gutter="0" style="margin-bottom: 5px; text-align: left;">
                    <van-col span="24">
                      <van-button style="color:#fff; border-color: #ddd; background-color: #EC8132; padding: 0 9px; margin-right: 5px; " plain hairline round  type="primary" size="mini">高管</van-button>
                      
                      <van-button style="color:#fff; border-color: #ddd; background-color: #0091AC; padding: 0 9px;"  plain hairline round  type="primary" size="mini">国企</van-button>
                      <van-button style="font-size: 0.3rem; color: #888; border-color: #fff;">时间:2021-08-10</van-button>
                    </van-col>

                  </van-row>

              </template>
                <template #right-icon>
                  <div style="display: flex;align-items: center;"><van-image
                    round
                    width="0.5rem"
                    height="0.5rem"
                    :src="require('@/assets/phone.png')"
                  /></div>
                </template>

            
          </van-cell>
      </van-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchKey:"",
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
    };
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    onClick() {
      
    },
    onLoad() {
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1)
        }
        // 加载状态结束
        this.loading = false
        // 数据全部加载完成
        if (this.list.length >= 10) {
          this.finished = true
        }
      }, 100)
    }
  },
  mounted() {
   
  },

}
</script>

<style lang="less" scoped>
.van-cell__value{color:#333;}
</style>
